import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface UserInfo {
  firstName: string;
  familyName: string;
}

@Component({
  selector: 'vi-user-avatar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class ViUserAvatarComponent implements OnChanges {
  initials: string;
  @Input() userInfo: UserInfo;

  ngOnChanges(): void {
    if (this.userInfo && this.userInfo.firstName && this.userInfo.familyName) {
      this.initials = `${this.userInfo.firstName.charAt(0)}${this.userInfo.familyName.charAt(0)}`;
    }
  }
}
